import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';
import {SortField as SortFields} from 'src/openapi/admin/models/SortField';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {NotificationSearchCriteria} from 'src/openapi/admin/models/NotificationSearchCriteria';
import type {SortField} from 'src/openapi/admin/models/SortField';

export const notificationsListStateSlice = getCachedTableStateSlice<
    undefined,
    SortField,
    NotificationSearchCriteria
>('notificationsListState', SortFields.START_DATE);

export const notificationsListStateActions = notificationsListStateSlice.actions;
export const notificationsListStateSelector:
CachedTableStateSelector<undefined, SortField, NotificationSearchCriteria> =
    state => state.internalNotification.notificationsList;
